<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <h6 class="element-header">
        Detailübersicht
      </h6>

      <div class="element-box">
        <div class="d-flex justify-content-end">
          <CreateButton
              :label="$t('general.button.back')"
              :to="{ name: 'analyticsUnemployedDetailsOverview',  params: {id: unemployedData.id} }">
          </CreateButton>

<!--          <CreateButton-->
<!--              class="ml-3"-->
<!--              variant="primary"-->
<!--              :label="$t('general.button.correction')"-->
<!--              :to="{ name: 'analyticsUnemployedDetailsOverview',  params: {id: 8174} }">-->
<!--          </CreateButton>-->
        </div>

        <div class="row">
          <div class="col-12 text-center">
            <h5 class="form-header">
              <span v-if="coachingType === 'private-coaching'">
                Einzelcoaching
              </span>
              <span v-if="coachingType === 'group-coaching'">
                Gruppenmaßnahmen
              </span>
              <span v-if="coachingType === 'socio-therapy-coaching'">
                Soziotherapie
              </span>
              <span v-if="coachingType === 'assisted-living-coaching'">
                Betreutes Wohnen
              </span>
              <span v-if="coachingType === 'case-management-coaching'">
                DRV Fallmanagement
              </span>
            </h5>
          </div>
        </div>

        <div class="row mb-5" style="text-align: center">
          <div class="col-12">
            <span style="font-weight: bold" class="mr-1">Kunden name::</span>{{ unemployedData?.firstName }}
          </div>
          <div class="col-12">
            <span style="font-weight: bold" class="mr-1">Kunden vorname:</span>{{ unemployedData?.lastName }}
          </div>
          <div class="col-12">
            <span style="font-weight: bold" class="mr-1">Kunden standort:</span>{{ unemployedData?.city }}
          </div>
          <div class="col-12">
            <span style="font-weight: bold"
                  class="mr-1"> Kunden status: :</span>{{ $t(`unemployed_status.${unemployedData?.status}`) }}
          </div>
        </div>

        <div class="table-responsive mb-3">
          <table class="table table-bordered">
            <tbody>
            <tr>
              <td>
                Maßnahmenbeginn: &nbsp; {{ coachingData.startDate }}<br>
                Maßnahmenende: &nbsp; {{ coachingData.endDate }}
              </td>
              <td>
                Maximale Einheiten: &nbsp;{{ coachingData.calculatedUnits.maxUnits }}<br>
                Einheiten erledigt: &nbsp;{{ coachingData.calculatedUnits.unitsDone }}
              </td>
              <td>
                Offene Einheiten: &nbsp;{{ coachingData.calculatedUnits.unitsLeft }}<br>
                Offene Einheiten pro Monat: &nbsp;<br>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="table-responsive" style="margin-bottom: 30px;">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Termin</th>
              <th>Start</th>
              <th>Ende</th>
              <th>Units</th>
              <th>Anwesenheit</th>
              <th>Unterschrift</th>
              <th>Abgerechnet</th>
              <th>Bezahlt</th>
              <th>Coach</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="meeting in meetings" :key="meeting.id">
              <td>{{ meeting?.termin}}</td>
              <td>{{ meeting?.startTime }}</td>
              <td>{{ meeting?.endTime }}</td>
              <td>{{ meeting?.units }}</td>
              <td>{{ $t(`presence_type.${meeting?.presence}`) }}</td>
              <td>{{ meeting?.signature ? "JA" : "NEIN" }}</td>
              <td>{{ meeting?.billed ? "JA" : "NEIN" }}</td>
              <td>{{ meeting?.paid ? "JA" : "NEIN" }}</td>
              <td>{{meeting?.coachFirstName}} {{ meeting?.coachLastName}}</td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </PageTemplate>
</template>

<script setup>
import analyticsUnemployedDetailsOverviewService from '@/api/Analytics/Unemployed/DetailsOverview';
import CreateButton from '@/components/CreateButton.vue';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import { ErrorToast } from '@/components/VueToast';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

const isLoaded     = ref(false);
const route        = useRoute();
const coachingId   = route.params.id;
const coachingType = route.params.coachingType;

const coachingData   = ref({});
const unemployedData = ref({});
const meetings       = ref([]);

async function getCoachingData() {
  try {
    let response;

    switch (coachingType) {
      case 'private-coaching':
        response = await analyticsUnemployedDetailsOverviewService.getPrivateCoachingDetails(coachingId);
        break;
      case 'group-coaching':
        response = await analyticsUnemployedDetailsOverviewService.getGroupCoachingDetails(coachingId);
        break;
      case 'socio-therapy-coaching':
        response = await analyticsUnemployedDetailsOverviewService.getSocioTherapyCoachingDetails(coachingId);
        break;
      case 'assisted-living-coaching':
        response = await analyticsUnemployedDetailsOverviewService.getAssistedLivingCoachingDetails(coachingId);
        break;
      case 'case-management-coaching':
        response = await analyticsUnemployedDetailsOverviewService.getCaseManagementCoachingDetails(coachingId);
        break;
      default:
    }

    if (response?.data) {
      coachingData.value   = response.data.data.coaching;
      unemployedData.value = response.data.data.coaching.unemployed;
      meetings.value       = response.data.data.meetingsList;
    }
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  await getCoachingData();
  isLoaded.value = true;
});


</script>

<style scoped>

</style>